// import requests from "./httpService";
// import getEmployeeId from "utils/commonAdmin";


// const VehicleServices = {
//   getVehicleList: async (type) => {
//     const id_employee =await getEmployeeId(); 
//     return requests.get(`/vehicle/employee/getAllList/${type}/${id_employee}`);
//   },

//   addVehicle: async (body) => {
//     const id_employee =await getEmployeeId(); 
//     return requests.post(`/vehicle/add/${id_employee}`, body);
//   },
//   getAllVehicle: async (body) => {
//     const id_employee =await getEmployeeId(); 
//     return requests.get(`/vehicle/employee/list/${id_employee}`, body);
//   },
//   getAllVehicleRequestQueue: async (body) => {
//     const id_employee =await getEmployeeId(); 
//     return requests.get(`/vehicle/employee/requestQueue/${id_employee}`, body);
//   },
//   getVehicleById: async (id, body) => {
//     return requests.get(`/vehicle/${id}`, body);
//   },
//   getVendorById: async (id, body) => {
//     return requests.get(`/vendor/company-name/${id}`, body);
//   },
//   // checkAlreadyExists: async (reg_no,vehicle_type, body) => {
//   //   return requests.get(`/vehicle/CheckVehicleExist/${reg_no}/${vehicle_type}`, body);
//   // },
//   updateVehicle: async (id, body) => {
//     const id_employee =await getEmployeeId(); 
//     return requests.put(`/vehicle/update/${id}/${id_employee}`, body);
//   },

//   deleteVehicle: async (id) => {
//     const id_employee =await getEmployeeId(); 
//     return requests.put(`/vehicle/delete/${id}/${id_employee}`);
//   },
//   // updateVehicleStatus:async(id,body) =>{
//   //   return requests.put(`/vehicle/status/${id}/${id_employee}`, body);
//   // },
//   updateVehicleBlockStatus: async (id, body) => {
//     const id_employee =await getEmployeeId(); 
//     return requests.put(`/vehicle/blockStatus/${id}/${id_employee}`, body);
//   },
//   requestUpdateQueue: async (id, body) => {
//     const id_employee =await getEmployeeId(); 
//     return requests.patch(`/vehicle/status/${id}/${id_employee}`, body);
//   },
// };

// export default VehicleServices;




import requests from "./httpService";
import getEmployeeId from "utils/commonAdmin";


const VehicleServices = {
  //get Vehicle
  getVehicleList: async (type) => {
    return requests.get(`/vehicle/getAllList/${type}`);
  },

  //add vehicle
  addVehicle: async (body) => {
    return requests.post(`/vehicle/add`, body);
  },

  //Approval or Reject
  requestUpdateQueue: async (id, body) => {
    return requests.patch(`vehicle/verify/${id}`, body);
  },

  //active, inactive, block
  updateVehicleBlockStatus: async (id, body) => {
    return requests.patch(`vehicle/block-status/${id}`, body);
  },

  //delete vehilce
  deleteVehicle: async (id) => {
    return requests.patch(`vehicle/delete-status/${id}`);
  },

  //updateVehicle
  updateVehicle: async (id, body) => {
    return requests.put(`/vehicle/update/${id}`, body);
  },

  getAllVehicleRequestQueue: async (body) => {
    const id_employee = await getEmployeeId();
    return requests.get(`/vehicle/employee/requestQueue/${id_employee}`, body);
  },
  getVehicleById: async (id, body) => {
    return requests.get(`/vehicle/${id}`, body);
  },
  getVendorById: async (id, body) => {
    return requests.get(`/vendor/company-name/${id}`, body);
  },

};

export default VehicleServices;
